import {
  ALLOW_WS_OVERRIDE,
  ASSISTANT_SMM_WS_QS_KEY,
  ASSISTANT_SMM_WS_SS_KEY,
  ASSISTANT_SMM_WS_URL,
} from '@skynet/config-provider';

import { createWsConnect } from '@skynet/data-ws-core';

import { prefix } from './actions';

/**
 * Resolves the Assistant SMM WebSocket URL from query-string, sessionStorage, or
 * the default env value, then dispatches a `connect` action for the SMM
 * channel.
 *
 * @example
 * store.dispatch(wsSmmConnect());
 */
export const wsSmmConnect = createWsConnect(prefix, {
  defaultUrl: ASSISTANT_SMM_WS_URL,
  ssKey: ASSISTANT_SMM_WS_SS_KEY,
  qsKey: ASSISTANT_SMM_WS_QS_KEY,
  allowOverride: ALLOW_WS_OVERRIDE,
});
